import {useI18next} from 'gatsby-plugin-react-i18next';
import React from 'react';
import styled from 'styled-components';

type IllustrationProps = {
  maxWidth?: number | string;
  className?: string;
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

const Card = styled.div<{maxWidth?: number | string}>`
  background: #ffffff;
  border-radius: 14px;
  padding: 28px 28px 32px;
  box-shadow: ${(props) => props.theme.boxShadow};
  width: 100%;
  max-width: ${(props) =>
    props.maxWidth
      ? typeof props.maxWidth === 'number'
        ? `${props.maxWidth}px`
        : props.maxWidth
      : '680px'};
  margin: 0 auto;

  @media (max-width: 768px) {
    border-radius: 12px;
    padding: 22px 20px 26px;
  }
  min-width: 300px;
`;

const Title = styled.h3`
  margin: 0 0 22px 0;
  font-weight: 500;
  color: #000;
`;

const Field = styled.div`
  margin-bottom: 18px;
`;

const Label = styled.div`
  color: rgba(0, 0, 0, 0.75);
  font-size: 16px;
  margin-bottom: 8px;
`;

const Value = styled.div`
  color: #000000;
  font-size: 16px;
`;

const CTA = styled.button`
  margin-top: 26px;
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 8px;
  color: #ffffff;
  font-weight: 500;
  background-image: linear-gradient(96.34deg, #00e9d5 0%, #7984d9 100%);
  box-shadow: ${(props) => props.theme.boxShadow};
`;

export const PayByLinkIllustration: React.FC<IllustrationProps> = ({maxWidth, className}) => {
  const {t, i18n} = useI18next();
  const formattedDate = React.useMemo(() => {
    try {
      return new Date().toLocaleDateString(i18n?.language || undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (e) {
      return new Date().toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }, [i18n?.language]);
  return (
    <Wrapper className={className}>
      <Card maxWidth={maxWidth}>
        <Title>{t('Order from [Your Brand]')}</Title>

        <Field>
          <Label>{t('Order ID')}</Label>
          <Value>#ORD-2025-0814-3942</Value>
        </Field>

        <Field>
          <Label>{t('Amount')}</Label>
          <Value>32€</Value>
        </Field>

        <Field>
          <Label>{t('Date')}</Label>
          <Value>{formattedDate}</Value>
        </Field>

        <Field>
          <Label>{t('Billed to')}</Label>
          <Value>John Doe</Value>
        </Field>

        <CTA>{t('Pay €')}</CTA>
      </Card>
    </Wrapper>
  );
};

export default PayByLinkIllustration;
